<template>
  <div class="Echarts" style="width: 100%;height:100%;">
    <div :id="'main'+startID" style="width: 100%;height:100%;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    // startTime: String,
    // endTime: String,
    kechartsData: {
      type: Object,
      required: true
    },
    startID: {
      type: String,
      default: ""
    },
    types: {
      type: Boolean,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      upColor: "#00da3c",
      downColor: "#ec0000",
      dataCount: 20,
      quoteData: [], // 时间
      seriesData: [],
      legendName: []
    };
  },
  methods: {
    optionInit() {
      const colors = [
        "#ff3600",
        "#1482F1",
        "#ff7a45",
        "#ffec3d",
        "#b37feb",
        "#ff85c0",
        "#bae637",
        "#73d13d",
        "#36cfc9",
        "#597ef7"
      ];
      this.quoteData= []; // 时间
      this.seriesData= [];
      this.legendName= [];
      if (this.types) {
        this.kechartsData.dataValue.forEach((item, idx) => {
          this.seriesData.push({
            name: item.name,
            itemStyle: {
              color: colors[idx]
            },
            type: "bar",
            // symbol: "none", // 去掉小圆点
            data: item.value
          });
        });
        this.quoteData = this.kechartsData.tiem;
        this.legendName = this.kechartsData.dataValue.map(item => item.name);
      } else {
        this.legendName = [];
        this.quoteData = this.kechartsData.tiem;
        this.seriesData.push({
          name: this.kechartsData.name,
          type: "bar",
          // symbol: "none", // 去掉小圆点
          data: this.kechartsData.value
        });
      }
    },
    echartsInit() {
      this.optionInit();
      var myChart = this.$echarts.init(
        document.getElementById("main" + this.startID)
      );
      var option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true
                }
            }
        },
        // toolbox: {
        //     show: true,
        //     feature: {
        //         mark: {show: true},
        //         dataView: {show: true, readOnly: false},
        //         magicType: {show: true, type: ['line', 'bar']},
        //         restore: {show: true},
        //         saveAsImage: {show: true}
        //     }
        // },
        calculable: true,
        legend: {
            data: this.legendName, //["2018", "2019"]
        },
        grid: {
            top: '12%',
            left: '1%',
            right: '10%',
            containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.quoteData
        },
        yAxis: {
          type: "value",
          scale: true
        },
        dataZoom: {
          
                show: true,
                start: 70,
                end: 100
            },
        series: this.seriesData
        // [
        //     {
        //         name: 'Budget 2011',
        //         type: 'bar',
        //         data: obama_budget_2012.budget2011List
        //     },
        //     {
        //         name: 'Budget 2012',
        //         type: 'bar',
        //         data: obama_budget_2012.budget2012List
        //     }
        // ]
    };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
    // myChartZoom() {
    //   const myChart = this.$echarts.init(document.getElementById("main"));
    //   const than = this;
    //   myChart.on("datazoom", function(params) {
    //     than.$emit("onZoomInit", params);
    //   });
    // }
  },
  mounted() {
    // this.echartsInit();
    // this.myChartZoom();
    window.addEventListener("resize", () => {
      this.$echarts
        .init(document.getElementById("main" + this.startID))
        .resize();
    });
  }
};
</script>
<style lang="less" scoped>
.Echarts {
  margin: 20px 0;
}
</style>
